export enum VrsRedirectTarget {
  InCenterTeamingNotice = 'inCenterTeamingNotice',
  TeamingLogoutNotice = 'teamingLogoutNotice',
}
